
export default function Contact() {
  return (
    <section id="contact" className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-[#9bc53d] text-sm font-semibold tracking-wider uppercase">Nossas Lojas</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2d5016] mt-4 mb-4 sm:mb-6">
            Visite-nos
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-2xl mx-auto px-4">
            Estamos em dois endereços em Paulínia para melhor atendê-lo
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 sm:gap-8 mb-12 sm:mb-16">
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
            <div className="p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#9bc53d] rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl sm:text-2xl text-white"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-[#2d5016]">Loja 1</h3>
              </div>
              <p className="text-gray-600 mb-2 text-base sm:text-lg">Av. João Aranha, 621</p>
              <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">Alto de Pinheiros, Paulínia - SP</p>
              
              <div className="mb-4 sm:mb-6">
                <iframe
                  src="https://maps.google.com/maps?q=Rancho%20da%20Verdura%2C%20Av.%20Jo%C3%A3o%20Aranha%2C%20621%20JD%20%E2%80%93%20Alto%20de%20Pinheiros%2C%20%20Paul%C3%ADnia%20%E2%80%93%20SP%2C%2013145-256&amp;t=m&amp;z=15&amp;output=embed&amp;iwloc=near"
                  className="w-full h-48 sm:h-56 md:h-64 rounded-xl"
                  loading="lazy"
                  title="Loja 1 - Rancho da Verdura"
                ></iframe>
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Rancho+da+Verdura+Av+João+Aranha+621+Paulínia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#2d5016] text-white px-4 sm:px-6 py-3 rounded-full text-xs sm:text-sm font-semibold hover:bg-[#9bc53d] transition-all duration-300 text-center whitespace-nowrap"
                >
                  Ver no Mapa
                </a>
                <a
                  href="https://wa.me/5519993773158"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#25D366] text-white px-4 sm:px-6 py-3 rounded-full text-xs sm:text-sm font-semibold hover:bg-[#128C7E] transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-base sm:text-lg"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300">
            <div className="p-6 sm:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#9bc53d] rounded-full flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl sm:text-2xl text-white"></i>
                </div>
                <h3 className="text-xl sm:text-2xl font-bold text-[#2d5016]">Loja 2</h3>
              </div>
              <p className="text-gray-600 mb-2 text-base sm:text-lg">Rua Professor Zeferino Vaz, 68</p>
              <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">Santa Terezinha, Paulínia - SP</p>
              
              <div className="mb-4 sm:mb-6">
                <iframe
                  src="https://maps.google.com/maps?q=Rancho%20da%20Verdura%2C%20Rua%20Professor%20Zeferino%20Vaz%2C%2068%20%E2%80%93%20Santa%20Terezinha%2C%20%20Paul%C3%ADnia%20%E2%80%93%20SP%2C%2013140-782&amp;t=m&amp;z=15&amp;output=embed&amp;iwloc=near"
                  className="w-full h-48 sm:h-56 md:h-64 rounded-xl"
                  loading="lazy"
                  title="Loja 2 - Rancho da Verdura"
                ></iframe>
              </div>

              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Rancho+da+Verdura+Rua+Professor+Zeferino+Vaz+68+Paulínia"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#2d5016] text-white px-4 sm:px-6 py-3 rounded-full text-xs sm:text-sm font-semibold hover:bg-[#9bc53d] transition-all duration-300 text-center whitespace-nowrap"
                >
                  Ver no Mapa
                </a>
                <a
                  href="https://wa.me/5519993773158"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 bg-[#25D366] text-white px-4 sm:px-6 py-3 rounded-full text-xs sm:text-sm font-semibold hover:bg-[#128C7E] transition-all duration-300 flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line text-base sm:text-lg"></i>
                  WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#2d5016] to-[#9bc53d] rounded-2xl p-6 sm:p-8 md:p-12 text-center text-white shadow-2xl">
          <h3 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4">Horário de Funcionamento</h3>
          <div className="max-w-md mx-auto space-y-2 text-base sm:text-lg">
            <p className="flex justify-between items-center px-4">
              <span>Segunda a Sábado:</span>
              <span className="font-semibold">7h às 21h</span>
            </p>
            <p className="flex justify-between items-center px-4">
              <span>Domingo:</span>
              <span className="font-semibold">7h às 15h</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
